const ORIGIN = window.location.origin

const getHome = (): URL => {
  const url = new URL(ORIGIN)
  return url
}

const getWPAjax = (): URL => {
  const url = getHome()
  url.pathname = '/wp/wp-admin/admin-ajax.php'
  return url
}

export const appUrls: Record<string, URL> = {
  home: getHome(),
  ajax: getWPAjax(),
}
